export default {
  title: 'Audiência de Teste',
  columns: {
    id: 'Id',
    phone_number: 'Número de Telefone',
  },
  filters: {
    search: {
      placeholder: 'Pesquisar',
    },
  },
  buttons: {
    send_test: 'Enviar Teste',
  },
  feedback: {
    success: 'Enviado com sucesso',
    error: 'Falha ao enviar',
  },
};
